import { mapModes } from 'client/utils/constants/appStates';
const { DEFAULT, AOI, ADDING_OBSERVATION } = mapModes;

export const VALID_MODES = [
    [DEFAULT, AOI],
    [DEFAULT, AOI, ADDING_OBSERVATION]
];
